import React, { forwardRef } from 'react';

/**
 * ScanTextInput — drop-in erstatning for <input type="text"> til skann/tekst-felter
 * på nettbrett der Enter skal utloese en handling (ikke bare flytte fokus).
 *
 * Problem som loeses:
 * - Android viser "Neste"-knapp som tab'er til neste felt i stedet for a sende Enter.
 * - Auto-forslag/autokorrigering kan odelegge strekkode-input.
 *
 * Tablet-vennlige defaults (kan overstyres via props):
 *   enterKeyHint="send"    -> ekte Enter-event pa virtuelt tastatur
 *   autoComplete="off"     -> ingen forslag
 *   autoCapitalize="off"   -> ingen stor forbokstav
 *   autoCorrect="off"      -> ingen autokorrektur (iOS)
 *   spellCheck={false}     -> ingen rod understreking
 *
 * Paavirker ikke:
 * - Fysiske strekkodelesere (sender fortsatt \r -> fanges av onKeyDown)
 * - Global barcode-hook (reagerer pa tastesekvens-hastighet, ikke input-attributter)
 */
export const ScanTextInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function ScanTextInput(props, ref) {
    return (
      <input
        ref={ref}
        type="text"
        enterKeyHint="send"
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        {...props}
      />
    );
  }
);
